import { combineReducers } from 'redux'
import ArrayUtil from '@leverege/array-util'

import { ProjectActions, BlueprintActions, Constants } from '~/actions/'

const initialProjectState = {
  projects : [],
  status : null
};

function projects( state = initialProjectState, action ) {

  switch ( action.type ) {

    case ProjectActions.LOADING_PROJECTS:
      return { projects : state.projects, status : ProjectActions.LOADING_PROJECTS };

    case ProjectActions.GET_PROJECTS:
      return { projects : action.projects, status : ProjectActions.GET_PROJECTS };

    case Constants.ADD_PROJECT: {
      const nProjects = [].concat( state.projects )
      nProjects.push( action.project )
      return { projects : nProjects, status : null }
    }
    
    case Constants.REMOVE_PROJECT: {
      const nProjects = [].concat( state.projects )
      ArrayUtil.remove( nProjects, 'id', action.id )
      return { projects : nProjects, status : null }
    }
    
    case ProjectActions.PROJECTS_ERROR:
      return { projects : [],
               status : { status : action.status,
                          message : action.message } };
    default:
      return state

  }
}

module.exports = projects;
